module.exports = __webpack_public_path__ + "img/DE00720.596d8bf3.png";